import { Wrapper } from "./styled";

const PageWrapper = ({ children }) => (
    <Wrapper>
        {children}
    </Wrapper>
)

export default PageWrapper;